"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageQuery = exports.getServerSideProps = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _TextButton = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/action/TextButton"));
var _Img = _interopRequireDefault(require("../Img"));
var _Body = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Body"));
var _Title = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Title"));
var _useSesame = _interopRequireDefault(require("@oberoninternal/travelbase-ds/hooks/useSesame"));
var _grid = require("@rebass/grid");
var _client = require("@apollo/client");
var _router = require("next/router");
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _messages = _interopRequireDefault(require("../../constants/messages"));
var _seoMessages = require("../../constants/seoMessages");
var _createApolloClient = require("../../createApolloClient");
var _NotFoundError = _interopRequireDefault(require("../../entities/NotFoundError"));
var _graphql = require("../../generated/graphql");
var _useCart = require("../../hooks/useCart");
var _useDateParam = _interopRequireDefault(require("../../hooks/useDateParam"));
var _cart = require("../../utils/cart");
var _createImgProps = _interopRequireDefault(require("../../utils/createImgProps"));
var _createTicketText = _interopRequireDefault(require("../../utils/createTicketText"));
var _getTargetAudienceMessage = _interopRequireDefault(require("../../utils/getTargetAudienceMessage"));
var _parseDateTime = _interopRequireDefault(require("../../utils/parseDateTime"));
var _setCanonicalLink = _interopRequireDefault(require("../../utils/setCanonicalLink"));
var _ActivityAlternatives = _interopRequireDefault(require("../ActivityAlternatives"));
var _ActivityCheckoutModal = _interopRequireDefault(require("../ActivityCheckoutModal"));
var _ActivityEateries = _interopRequireDefault(require("../ActivityEateries"));
var _ActivityPlanner = _interopRequireDefault(require("../ActivityPlanner"));
var _ActivityPlannerModal = _interopRequireDefault(require("../ActivityPlannerModal"));
var _ContentWrapper = _interopRequireDefault(require("../ContentWrapper"));
var _Cell = _interopRequireDefault(require("../designsystem/Cell"));
var _GradientBackground = _interopRequireDefault(require("../designsystem/GradientBackground"));
var _Grid = _interopRequireDefault(require("../designsystem/Grid"));
var _Heading = _interopRequireDefault(require("../designsystem/Heading"));
var _Hero = _interopRequireWildcard(require("../Hero"));
var _Nav = _interopRequireDefault(require("../designsystem/Nav"));
var _Section = _interopRequireDefault(require("../designsystem/Section"));
var _TextClamp = _interopRequireDefault(require("../designsystem/TextClamp"));
var _Divider = require("../Divider");
var _Intro = _interopRequireDefault(require("../Intro"));
var _LoadingDetail = _interopRequireDefault(require("../LoadingDetail"));
var _LocationMap = _interopRequireWildcard(require("../LocationMap"));
var _Page = _interopRequireDefault(require("../Page"));
var _PhotoSection = _interopRequireDefault(require("../PhotoSection"));
var _StickyBar = _interopRequireWildcard(require("../StickyBar"));
var _Capacity = _interopRequireDefault(require("../svg/Capacity.svg"));
var _Flag = _interopRequireDefault(require("../svg/Flag.svg"));
var _Link = _interopRequireDefault(require("../svg/Link.svg"));
var _Location = _interopRequireDefault(require("../svg/Location.svg"));
var _TargetAudience = _interopRequireDefault(require("../svg/TargetAudience.svg"));
var _TwoColumnIntro = _interopRequireWildcard(require("../TwoColumnIntro"));
var _Play = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/figure/Play"));
var _MediaButton = _interopRequireDefault(require("../designsystem/MediaButton"));
var _VideoModal = _interopRequireDefault(require("../VideoModal"));
var _ActivityTickets = _interopRequireDefault(require("../ActivityTickets"));
var _useUpdateCart = require("../../hooks/useUpdateCart");
var _head = _interopRequireDefault(require("next/head"));
var _TenantContext = require("../../context/TenantContext");
var _FavoriteButton = _interopRequireDefault(require("../FavoriteButton"));
var _startOfMonth = _interopRequireDefault(require("date-fns/startOfMonth"));
var _dateFns = require("date-fns");
var _parseToDateString = _interopRequireDefault(require("../../constants/parseToDateString"));
var _useAnalyticsActivityView = _interopRequireDefault(require("../../hooks/analytics/useAnalyticsActivityView"));
var _link = _interopRequireDefault(require("next/link"));
var _Button = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/action/Button"));
var _useGetPageSlugByLocale = _interopRequireDefault(require("../../hooks/useGetPageSlugByLocale"));
var _ActivityStickyBar = _interopRequireDefault(require("../ActivityStickyBar"));
var _Reviews = _interopRequireDefault(require("../Reviews"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const pageQuery = exports.pageQuery = (0, _client.gql)`
    query ActivityDetail($slug: String!) {
        activity(slug: $slug) {
            id
            slug
            externalBookingUrl
            externalInfoUrl
            bookingType
            videoUrl
            jpegHero: mainImage {
                transform(config: HERO, format: JPEG) {
                    ...Transform
                }
            }
            webpHero: mainImage {
                transform(config: HERO, format: WEBP) {
                    ...Transform
                }
            }
            jpegThumbnail: listImage {
                transform(config: TILE, format: JPEG) {
                    ...Transform
                }
            }
            webpThumbnail: listImage {
                transform(config: TILE, format: WEBP) {
                    ...Transform
                }
            }
            place
            name
            minCapacity
            maxCapacity
            targetAudiences
            themes {
                id
                name
            }
            activityReviewStats{
                count
                average
                activity
                hospitality
                valueForMoney
            }

            activityReviews(limit: 3, offset: 0) {
                ...ActivityReviews
            }
            description

            # location section
            coordinates {
                lat
                lon
            }
            descriptionLocation

            # particulars section
            descriptionParticulars

            # images section
            images {
                jpegTile: transform(config: TILE, format: JPEG) {
                    ...Transform
                }
                webpTile: transform(config: TILE, format: WEBP) {
                    ...Transform
                }
                jpegGallery: transform(config: GALLERY, format: JPEG) {
                    ...Transform
                }
                webpGallery: transform(config: GALLERY, format: WEBP) {
                    ...Transform
                }
            }

            # company info section

            company {
                id
                name
                description
                slug
                webpMain: mainImage {
                    transform(config: HERO, format: WEBP) {
                        ...Transform
                    }
                }
                jpegMain: mainImage {
                    transform(config: HERO, format: JPEG) {
                        ...Transform
                    }
                }
                ...CompanyOperatingHours
            }
        }
    }
`;
const isNumber = (...vals) => vals.every(val => typeof val === 'number');
const ActivityDetail = () => {
  const router = (0, _router.useRouter)();
  const slug = router.query.slug;
  const {
    onOpen,
    onClose,
    open
  } = (0, _useSesame.default)();
  const ticketModal = (0, _useSesame.default)();
  const {
    getPageSlugByLocale
  } = (0, _useGetPageSlugByLocale.default)();
  const companyPageSlug = getPageSlugByLocale('COMPANY');
  const {
    0: activityTickets,
    1: setActivityTickets
  } = (0, _react.useState)(false);
  const {
    0: openActivityTickets,
    1: setOpenActivityTickets
  } = (0, _react.useState)(false);
  const {
    0: openActivityPlanner,
    1: setOpenActivityPlanner
  } = (0, _react.useState)(false);
  const intl = (0, _reactIntl.useIntl)();
  const cart = (0, _useCart.useCart)();
  const currentTickets = cart.cartQuery.data?.cart?.status === _graphql.CartStatusEnum.Open ? cart.tickets.filter(item => item.activity?.slug === slug) : [];
  const {
    0: timeslot,
    1: setSelectedTimeslot
  } = (0, _react.useState)(null);
  const currentTicket = currentTickets.find(ticket => ticket.timeslot?.id === timeslot?.id);
  const onSetTimeslot = slot => {
    setSelectedTimeslot(slot);
    setActivityTickets(true);
    setOpenActivityTickets(true);
  };
  const plannerModal = (0, _useSesame.default)();
  const [selectedDay, setSelectedDay] = (0, _useDateParam.default)();
  const {
    0: selectedDayIsBookable,
    1: setSelectedDayIsBookable
  } = (0, _react.useState)(false);
  const {
    open: videoModalIsOpen,
    onOpen: onOpenVideoModal,
    onClose: onCloseVideoModal
  } = (0, _useSesame.default)();
  const {
    brandConfig
  } = (0, _TenantContext.useTenantContext)();
  const ticketText = currentTickets.length > 0 ? intl.formatList(currentTickets.map(ticket => {
    if (!ticket.timeslot?.id) {
      return null;
    }
    return __jsx(_TextButton.default, {
      onClick: () => {
        plannerModal.onOpen();
        setSelectedDay((0, _parseDateTime.default)(ticket.startDateTime));
      },
      size: "tiny",
      key: ticket.timeslot.id
    }, (0, _createTicketText.default)(intl, ticket.startDateTime, ticket.rateLines));
  })) : null;
  const {
    loading,
    data
  } = (0, _graphql.useActivityDetailQuery)({
    variables: {
      slug
    }
  });

  // preload selected / first month before modal opens
  (0, _graphql.useActivityPlannerQuery)({
    variables: {
      startDate: (0, _parseToDateString.default)((0, _startOfMonth.default)(selectedDay ?? new Date())),
      endDate: (0, _parseToDateString.default)((0, _dateFns.endOfMonth)(selectedDay ?? new Date())),
      slug
    }
  });
  const modalRef = (0, _react.useRef)(null);
  const updateCart = (0, _useUpdateCart.useUpdateCart)(timeslot, slug, data?.activity?.id);
  (0, _useAnalyticsActivityView.default)(data?.activity);
  const onEdit = () => {
    setActivityTickets(false);
  };
  if (loading) {
    return __jsx(_LoadingDetail.default, {
      withHero: true
    });
  }
  if (!data?.activity) {
    throw new _NotFoundError.default();
  }
  const {
    images,
    jpegHero,
    webpHero,
    jpegThumbnail,
    webpThumbnail,
    name,
    activityReviewStats,
    activityReviews,
    minCapacity,
    maxCapacity,
    targetAudiences,
    place,
    externalBookingUrl,
    externalInfoUrl,
    coordinates,
    themes,
    descriptionLocation,
    descriptionParticulars,
    company,
    description,
    videoUrl,
    bookingType,
    id
  } = data.activity;
  const renderHero = (webp, jpeg, className) => __jsx(_Hero.default, (0, _extends2.default)({
    ratio: 9 / 16
  }, (0, _createImgProps.default)(jpeg, webp), {
    className: className
  }), images.length > 0 && __jsx(_Hero.HeroButtonsMobile, null, __jsx(_Hero.HeroPhotosButton, {
    onClick: onOpen
  }, images.length), videoUrl && __jsx(_MediaButton.default, {
    icon: __jsx(_Play.default, null),
    onClick: () => onOpenVideoModal()
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "kBJUtE",
    defaultMessage: [{
      "type": 0,
      "value": "Video"
    }]
  }))), __jsx(_Hero.HeroButtonsDesktop, null, __jsx(_Hero.HeroPhotosButton, {
    onClick: onOpen
  }, images.length), videoUrl && __jsx(_MediaButton.default, {
    icon: __jsx(_Play.default, null),
    onClick: () => onOpenVideoModal()
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "tmQeUp",
    defaultMessage: [{
      "type": 0,
      "value": "Video bekijken"
    }]
  }))));
  const {
    title: seoTitle,
    description: seoDescription
  } = (0, _seoMessages.getActivitySeoMessages)(data.activity, intl);
  const scrollOptions = {
    scrollRef: modalRef
  };
  const buyTickets = async () => {
    if (!(0, _cart.getCartId)()) {
      return;
    }
    await router.push(`/checkout/extras`);
  };
  const onActivityBack = () => {
    if (openActivityTickets) {
      setOpenActivityTickets(false);
    } else if (openActivityPlanner && !openActivityTickets) {
      setOpenActivityPlanner(false);
      setOpenActivityTickets(false);
    }
  };
  const onActivityPlanner = () => {
    setOpenActivityPlanner(true);
    setOpenActivityTickets(false);
  };
  const pathname = `/${companyPageSlug}/${company?.slug}`;
  const renderCompanyButton = className => __jsx(_link.default, {
    href: {
      pathname
    },
    passHref: true
  }, __jsx(_Button.default, {
    style: {
      display: 'inline-flex'
    },
    as: "a",
    className: className,
    variant: "outline"
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "110NwM",
    defaultMessage: [{
      "type": 0,
      "value": "Bekijk "
    }, {
      "type": 1,
      "value": "name"
    }],
    values: {
      name: company?.name
    }
  })));
  return __jsx(_react.default.Fragment, null, __jsx(_head.default, null, __jsx("title", null, `${seoTitle} - ${brandConfig.seo.siteName}`), __jsx("meta", {
    name: "description",
    content: seoDescription
  }), __jsx("meta", {
    property: "og:title",
    content: seoTitle
  }), __jsx("meta", {
    name: "og:description",
    content: seoDescription
  }), jpegThumbnail?.transform?.src && __jsx("meta", {
    property: "og:image",
    content: jpegThumbnail.transform.src
  }), __jsx("meta", {
    property: "og:description",
    content: seoDescription
  }), __jsx("meta", {
    property: "og:image:alt",
    content: seoTitle
  }), __jsx("meta", {
    name: "twitter:card",
    content: "summary_large_image"
  }), __jsx("meta", {
    name: "twitter:title",
    content: seoTitle
  }), __jsx("meta", {
    name: "twitter:description",
    content: seoDescription
  }), jpegThumbnail?.transform?.src && __jsx("meta", {
    name: "twitter:image",
    content: jpegThumbnail.transform.src
  }), __jsx("meta", {
    name: "twitter:image:alt",
    content: seoTitle
  })), __jsx(_Page.default, {
    pb: "var(--booking-bar-height)"
  }, videoUrl && __jsx(_VideoModal.default, {
    open: videoModalIsOpen,
    onClose: onCloseVideoModal,
    src: videoUrl
  }), __jsx(_Hero.HeroContainer, null, webpHero && jpegHero && renderHero(webpHero, jpegHero), (!webpHero || !jpegHero) && webpThumbnail && jpegThumbnail && renderHero(webpThumbnail, jpegThumbnail, 'lt-s')), __jsx(_Section.default, {
    name: "intro"
  }, __jsx(_TwoColumnIntro.default, {
    leftChildren: __jsx(_react.default.Fragment, null, __jsx(_Intro.default, {
      description: description ?? undefined,
      tagline: name,
      rating: activityReviewStats?.average
    }), brandConfig.enableFavorites && __jsx(_grid.Box, {
      mb: [0, null, '64px'],
      mt: [8, null, 0]
    }, __jsx(_FavoriteButton.default, {
      type: "activity",
      id: id
    }))),
    rightChildren: __jsx(_react.default.Fragment, null, __jsx(_Heading.default, {
      variant: "small"
    }, __jsx(_Title.default, null, __jsx(_reactIntl.FormattedMessage, {
      id: "csQdw2",
      defaultMessage: [{
        "type": 0,
        "value": "Praktisch"
      }]
    }))), __jsx(_TwoColumnIntro.PracticalList, null, isNumber(minCapacity, maxCapacity) && __jsx("li", null, __jsx(_Capacity.default, null), __jsx(_Body.default, null, minCapacity !== maxCapacity ? __jsx(_reactIntl.FormattedMessage, {
      id: "FKaYeA",
      defaultMessage: [{
        "type": 1,
        "value": "minCapacity"
      }, {
        "type": 0,
        "value": " tot "
      }, {
        "type": 1,
        "value": "maxCapacity"
      }, {
        "type": 0,
        "value": " personen"
      }],
      values: {
        minCapacity,
        maxCapacity
      }
    }) : intl.formatMessage(_messages.default.persons, {
      amountPersons: minCapacity
    }))), place && __jsx("li", null, __jsx(_Location.default, {
      width: 24
    }), __jsx(_Body.default, null, place)), themes.length > 0 && __jsx("li", null, __jsx(_Flag.default, null), __jsx(_Body.default, null, __jsx(_reactIntl.FormattedList, {
      value: themes.map(theme => theme.name),
      type: "conjunction"
    }))), targetAudiences && __jsx("li", null, __jsx(_TargetAudience.default, null), __jsx(TargetAudienceBody, null, __jsx(_reactIntl.FormattedList, {
      value: targetAudiences.map(targetAudience => (0, _getTargetAudienceMessage.default)(targetAudience, intl)),
      type: "conjunction"
    }))), bookingType === _graphql.ActivityBookingTypesEnum.NotBookable && externalInfoUrl && __jsx("li", null, __jsx(_Link.default, null), __jsx("a", {
      href: externalInfoUrl,
      target: "_blank",
      rel: "noreferrer noopener"
    }, new URL(externalInfoUrl).hostname))))
  })), __jsx(_Divider.SectionDivider, null), __jsx(_PhotoSection.default, {
    open: open,
    onClose: onClose,
    onOpen: onOpen,
    photos: images
  }), __jsx(_Section.default, {
    id: "location"
  }, __jsx(_GradientBackground.default, null), __jsx(_ContentWrapper.default, null, __jsx(_Grid.default, null, __jsx(_Cell.default, {
    gridColumn: ['1 / -1', null, null, '1 / 5', null, '1 / 6']
  }, __jsx(_Heading.default, null, __jsx(_Title.default, {
    variant: "large",
    elementType: "h2"
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "RaL11F",
    defaultMessage: [{
      "type": 0,
      "value": "Locatie"
    }]
  }))), descriptionLocation && __jsx(_TextClamp.default, {
    text: descriptionLocation
  })), coordinates && __jsx(_Cell.default, {
    mt: [6, null, null, 0],
    gridColumn: ['1 / -1', null, null, '5 / -1', null, '6 / -1']
  }, __jsx(_LocationMap.default, {
    markerElement: "flag",
    iconUrl: `${process.env.NEXT_PUBLIC_BASE_URL ? `${process.env.NEXT_PUBLIC_BASE_URL}/static/img/flagMarker.png` : _LocationMap.devMarkerUrl}`,
    iconUrl2x: `${process.env.NEXT_PUBLIC_BASE_URL ? `${process.env.NEXT_PUBLIC_BASE_URL}/static/img/flagMarker2x.png` : _LocationMap.devMarkerUrl2x}`,
    position: {
      longitude: coordinates.lon,
      latitude: coordinates.lat
    },
    markerPosition: {
      longitude: coordinates.lon,
      latitude: coordinates.lat
    }
  }))))), __jsx(_Divider.SectionDivider, null), descriptionParticulars && __jsx(_Section.default, {
    id: "particulars"
  }, __jsx(_ContentWrapper.default, null, __jsx(_Heading.default, null, __jsx(_Title.default, {
    variant: "large",
    elementType: "h2"
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "7iaeht",
    defaultMessage: [{
      "type": 0,
      "value": "Belangrijk om te weten"
    }]
  }))), __jsx(_TextClamp.default, {
    style: {
      maxWidth: '56.8rem'
    },
    text: descriptionParticulars
  }))), __jsx(_Divider.SectionDivider, null), __jsx(_Section.default, {
    className: "gt-s",
    id: "prices"
  }, __jsx(ActivityContentWrapper, null, !activityTickets && __jsx(_ActivityPlanner.default, {
    activity: data.activity,
    setSelectedDayIsBookable: setSelectedDayIsBookable,
    slug: slug,
    selectedDay: selectedDay,
    setSelectedDay: setSelectedDay,
    setTimeslot: onSetTimeslot
  }), activityTickets && __jsx(_ActivityTickets.default, {
    activity: data.activity,
    setTicket: updateCart,
    onClose: ticketModal.onClose,
    open: ticketModal.open,
    timeslot: timeslot,
    ticket: currentTicket ? (0, _useCart.getTicketInput)(currentTicket) : null,
    setEdit: onEdit
  }))), __jsx(_Section.default, {
    id: "company"
  }, __jsx(ActivityContentWrapper, null, __jsx(_grid.Flex, {
    flexDirection: ['column', null, 'row', null],
    justifyContent: "space-around",
    mr: [0, null, 6],
    mb: [6, null, 0]
  }, activityReviewStats && activityReviews && __jsx(_grid.Box, {
    flex: 1
  }, __jsx(_Reviews.default, {
    reviewStats: activityReviewStats,
    reviews: activityReviews,
    slug: slug,
    ownerName: company?.name,
    ownerImage: jpegHero && webpHero && (0, _createImgProps.default)(jpegHero, webpHero)
  })), company && __jsx(_grid.Box, {
    flex: 1
  }, company.jpegMain && company.webpMain && __jsx(_grid.Box, {
    flex: 1,
    width: "100%"
  }, __jsx(_Heading.default, {
    className: "lt-s"
  }, __jsx(_Title.default, {
    variant: "large",
    elementType: "h2"
  }, company?.name)), __jsx(_grid.Box, {
    pb: [0, null, 5]
  }, __jsx(_grid.Box, {
    pb: [0, null, 6]
  }, __jsx(_Img.default, (0, _extends2.default)({
    layout: "ratio",
    ratio: 9 / 16,
    loading: "lazy"
  }, (0, _createImgProps.default)(company.jpegMain, company.webpMain)))), renderCompanyButton('gt-m'))), __jsx(_grid.Box, {
    flex: 1
  }, __jsx(_Heading.default, {
    className: "gt-s"
  }, __jsx(_Title.default, {
    variant: "large",
    elementType: "h2"
  }, company?.name)), __jsx(_grid.Box, {
    pb: [0, null, 4]
  }, company.description && __jsx(_TextClamp.default, {
    alwaysClamp: true,
    style: {
      marginTop: '3.2rem'
    },
    text: company.description
  }))))))), bookingType !== _graphql.ActivityBookingTypesEnum.Direct && __jsx(_ActivityAlternatives.default, {
    currentActivitySlug: slug
  }), __jsx(_ActivityEateries.default, {
    coordinates: coordinates
  })), __jsx(_StickyBar.default, null, jpegThumbnail && webpThumbnail && __jsx(_StickyBar.StickyBarThumnail, {
    className: "gt-l",
    title: name,
    thumbnail: _objectSpread({}, (0, _createImgProps.default)(jpegThumbnail, webpThumbnail, undefined, {
      loading: 'lazy'
    }))
  }), __jsx(_Nav.default, {
    className: "gt-s",
    items: [{
      label: __jsx(_reactIntl.FormattedMessage, {
        id: "o3H3Tu",
        defaultMessage: [{
          "type": 0,
          "value": "Overzicht"
        }]
      }),
      name: 'intro'
    }, {
      label: __jsx(_reactIntl.FormattedMessage, {
        id: "0xAinF",
        defaultMessage: [{
          "type": 0,
          "value": "Ligging"
        }]
      }),
      name: 'location'
    }, ...(descriptionParticulars ? [{
      label: __jsx(_reactIntl.FormattedMessage, {
        id: "oZMOUM",
        defaultMessage: [{
          "type": 0,
          "value": "Belangrijk"
        }]
      }),
      name: 'particulars'
    }] : []), {
      label: __jsx(_reactIntl.FormattedMessage, {
        id: "GIL6tw",
        defaultMessage: [{
          "type": 0,
          "value": "Prijs"
        }]
      }),
      name: 'prices',
      className: 'gt-s'
    }]
  }), __jsx(_ActivityStickyBar.default, {
    bookingType: bookingType,
    selectedDayIsBookable: selectedDayIsBookable,
    ticketText: ticketText,
    externalBookingUrl: externalBookingUrl,
    onPlannerModalOpen: plannerModal.onOpen,
    onBuyTickets: buyTickets
  })), __jsx(_ActivityCheckoutModal.default, {
    activity: data.activity,
    setTicket: updateCart,
    onClose: ticketModal.onClose,
    open: ticketModal.open,
    timeslot: timeslot,
    ticket: currentTicket ? (0, _useCart.getTicketInput)(currentTicket) : null
  }), __jsx(_ActivityPlannerModal.default, {
    activity: data.activity,
    slug: slug,
    selectedDay: selectedDay,
    setSelectedDay: setSelectedDay,
    open: plannerModal.open,
    onClose: plannerModal.onClose,
    setTimeslot: onSetTimeslot,
    onSelectScrollOpts: scrollOptions,
    setSelectedDayIsBookable: setSelectedDayIsBookable,
    setTicket: updateCart,
    ticket: currentTicket ? (0, _useCart.getTicketInput)(currentTicket) : null,
    timeslot: timeslot,
    setEdit: onEdit,
    activityTickets: activityTickets,
    openActivityTickets: openActivityTickets,
    onActvityBack: onActivityBack,
    openActivityPlanner: openActivityPlanner,
    onActivityPlanner: onActivityPlanner,
    onModalClose: plannerModal.onClose
  }));
};
var _default = exports.default = ActivityDetail;
const ActivityContentWrapper = (0, _styledComponents.default)(_ContentWrapper.default).withConfig({
  displayName: "ActivityDetail__ActivityContentWrapper",
  componentId: "sc-1nd4zp1-0"
})(["padding-bottom:0px !important;"]);
const TargetAudienceBody = (0, _styledComponents.default)(_Body.default).withConfig({
  displayName: "ActivityDetail__TargetAudienceBody",
  componentId: "sc-1nd4zp1-1"
})(["::first-letter{text-transform:capitalize;}"]);
const getServerSideProps = async ctx => {
  const {
    query,
    req,
    res,
    locale
  } = ctx;
  (0, _setCanonicalLink.default)(req, res);
  const client = (0, _createApolloClient.initApolloClient)(locale);
  const {
    data
  } = await client.query({
    query: _graphql.ActivityDetailDocument,
    variables: {
      slug: query.slug
    }
  });
  if (!data?.activity) {
    return {
      notFound: true
    };
  }
  return (0, _createApolloClient.addApolloState)(client, {
    props: {}
  });
};
exports.getServerSideProps = getServerSideProps;